import React from 'react';
import PropTypes from 'prop-types';
import { Card, Grid, Icon, Image } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withSnackbar } from 'stoerk-ui-components';
import GroupMyDevicesOverview from '../GroupMyDevices/Overview/GroupMyDeviceOverviewGridSmall';
import DeviceIcon from '../../../../assets/IconST7Landscape.svg';
import { withPolyglot } from '../../../../i18n';
import {
  STATUS_OK,
  STATUS_ALERT,
  STATUS_OK_INPROGRESS,
  STATUS_ALERT_INPROGRESS,
} from '../Constants';
import { getUnAssignedDevices } from '../../../../redux/groups/selectors';

const cssGroupsStatus = {};
cssGroupsStatus[STATUS_OK] = 'ok';
cssGroupsStatus[STATUS_ALERT] = 'alert';
cssGroupsStatus[STATUS_OK_INPROGRESS] = 'ok_inprogress';
cssGroupsStatus[STATUS_ALERT_INPROGRESS] = 'alert_inprogress';

export function GroupsOverviewGridSmall(props) {
  const { groups, groupIdParent, navigate, myDevices } = props;
  /* get devices associated to the user and not located in a group */
  const devices = myDevices;
  return (
    <div>
      <Card.Group className="groups-overview-grid-small">
        {/* If the group is the root group and the variable devicesTotal > 0,
            then the seudo group mydevices will be shown */}
        {groupIdParent === null && devices.length > 0 && (
          <GroupMyDevicesOverview />
        )}
        {groups.map((group) => (
          <Card
            key={group.id}
            className={`group ${cssGroupsStatus[group.status]}`}
          >
            <Card.Content className="toolbar-buttons">
              {props.buttonsActions(group)}
            </Card.Content>

            <Card.Content className="description" textAlign="center">
              <Grid>
                <Grid.Row
                  columns="1"
                  onClick={() => navigate(group.id)}
                  textAlign="center"
                >
                  <Grid.Column
                    textAlign="center"
                    verticalAlign="middle"
                    className="link name"
                  >
                    {group.name}
                  </Grid.Column>
                </Grid.Row>
                {(group.attributes.contacts &&
                  group.attributes.contacts.length > 0) ||
                (group.devices && group.devices.length > 0) ? (
                  <Grid.Row columns="2">
                    <Grid.Column
                      textAlign="left"
                      verticalAlign="middle"
                      width={4}
                    >
                      {group.devices && group.devices.length > 0 && (
                        <div>
                          <Image
                            src={DeviceIcon}
                            size="mini"
                            inline
                            label={{
                              content: group.devices.length,
                              color: 'red',
                              size: 'mini',
                              floating: true,
                              circular: true,
                              className: 'label-quantity-device',
                            }}
                            className="icon-devices"
                            id="iconQuantityDevices"
                          />
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column
                      textAlign="right"
                      verticalAlign="middle"
                      onClick={(event) => props.openContacts(event, group)}
                      width={12}
                    >
                      {group.attributes.contacts.length > 0 && (
                        <label
                          htmlFor="iconContactList"
                          className="contact-list link"
                        >
                          {props.polyglot.t('group.contact_list')}
                          <Icon
                            className="no-border"
                            name="address book outline"
                            size="large"
                            id="iconContactList"
                          />
                        </label>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                ) : (
                  ''
                )}
              </Grid>
            </Card.Content>
          </Card>
        ))}
      </Card.Group>
    </div>
  );
}

GroupsOverviewGridSmall.propTypes = {
  polyglot: PropTypes.shape({
    t: PropTypes.func,
    locale: PropTypes.func,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      iconURL: PropTypes.string,
      status: PropTypes.string,
      childGroups: PropTypes.array,
      devices: PropTypes.array,
      attributes: PropTypes.object,
    })
  ).isRequired,
  myDevices: PropTypes.arrayOf(PropTypes.object).isRequired,
  groupIdParent: PropTypes.string,
  buttonsActions: PropTypes.func.isRequired,
  openContacts: PropTypes.func.isRequired,
};

GroupsOverviewGridSmall.defaultProps = {
  groupIdParent: null,
};

const mapStateToProps = (state, props) => ({
  myDevices: getUnAssignedDevices(state, props),
});

export default connect(mapStateToProps)(
  withSnackbar(withPolyglot(GroupsOverviewGridSmall))
);
